class NotWrappedError extends Error {
  constructor() {
    super(
      "You are trying to access auth outside of AuthProvdier. wrap your application with AuthProvider",
    );
  }
}

export default NotWrappedError;
